import { name } from './constants';
export var viewSelector = function (state) { return state[name]; };
export var selectActiveSoonLiveTab = function (state) {
    return viewSelector(state).activeSoonLiveTab;
};
export var selectIsMobileTopRankingHidden = function (state) {
    return viewSelector(state).isMobileTopRankingHidden;
};
